import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Marquee = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 21V11a7 7 0 0 1 5.426-6.822m1.789 3.227s-.172 4.428-5.76 7.095M6 21a14.5 14.5 0 0 1-1-6m-1.5-2.437a12.1 12.1 0 0 0 2.88-4.857M21 21V11a7 7 0 0 0-5.426-6.822m-1.789 3.227s.172 4.428 5.76 7.093M17 21a14.5 14.5 0 0 0 1-6m1.5-2.437a12.1 12.1 0 0 1-2.88-4.857M1 21h8m2 0h2m3 0h6M12.9 2a1.52 1.52 0 0 0-1.4.942A1.52 1.52 0 0 0 10.1 2a1.66 1.66 0 0 0-1.521 1.674C8.579 5.509 11.111 7 11.5 7s2.921-1.491 2.921-3.326A1.66 1.66 0 0 0 12.9 2"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Marquee) as SvgIcon;
export { ForwardRef as ReactComponent };
